import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {
  JournalEntryReportsFilterType,
  defaultJournalEntryReportsFilter,
} from '../journal-entries-reports-filter.type';

interface JournalEntriesReportsFilterProps {
  filters: JournalEntryReportsFilterType;
  loading?: boolean;
  onChange: (filters: JournalEntryReportsFilterType) => void;
  onSearch: () => void;
  onClear?: () => void;
}

export const JournalEntriesReportsFilter: React.FC<
  JournalEntriesReportsFilterProps
> = ({ filters, loading, onChange, onSearch, onClear }) => {
  const update = <K extends keyof JournalEntryReportsFilterType>(
    key: K,
    value: JournalEntryReportsFilterType[K],
  ) => {
    onChange({ ...filters, [key]: value });
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }
    onChange(defaultJournalEntryReportsFilter());
  };

  const styles = {
    container: {
      background: 'white',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '12px',
    },
    title: {
      fontSize: '1.1rem',
      fontWeight: 600 as const,
      color: '#333',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '12px',
    },
    field: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '4px',
    },
    label: {
      fontSize: '0.8rem',
      color: '#555',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flexWrap: 'wrap' as const,
      gap: '12px',
      borderTop: '1px solid #eee',
      paddingTop: '12px',
    },
    buttonsRow: {
      display: 'flex',
      gap: '8px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>סינונים</div>

      <div style={styles.grid}>
        <div style={styles.field}>
          <label style={styles.label}>מתאריך</label>
          <Calendar
            value={filters.startDateFrom}
            onChange={(e) => update('startDateFrom', (e.value as Date) ?? null)}
            dateFormat="dd/mm/yy"
            showIcon
            showButtonBar
            placeholder="מתאריך"
            style={{ width: '100%', direction: 'ltr' }}
            inputStyle={{ direction: 'rtl', width: '100%' }}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>עד תאריך</label>
          <Calendar
            value={filters.endDateFrom}
            onChange={(e) => update('endDateFrom', (e.value as Date) ?? null)}
            dateFormat="dd/mm/yy"
            showIcon
            showButtonBar
            placeholder="עד תאריך"
            style={{ width: '100%', direction: 'ltr' }}
            inputStyle={{ direction: 'rtl', width: '100%' }}
          />
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.buttonsRow}>
          <Button
            icon="pi pi-filter-slash"
            label="נקה"
            text
            severity="secondary"
            onClick={handleClear}
            disabled={loading}
          />
          <Button
            icon="pi pi-search"
            label="חפש"
            onClick={onSearch}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};
